import { Button, Modal, Input, Form, Select, message, Col, Row, DatePicker, Divider, List, Card, Space, Typography } from 'antd';
import moment from 'moment';
import axios from 'axios';

import { requestError } from '../../controllers/functions';
import { useEffect, useState } from 'react';
import { useCallback } from 'react';

const { Text } = Typography;
const { Option } = Select;

const PaymentModal = ({ type, show, setOpenModal, schoolId, extractTokenFromUrl, getPayments }) => {

  const [form] = Form.useForm();
  const [ currences, setCurrencies ] = useState([]);
  const [ items, setItems ] = useState([]);
  const [ loading, setLoading ] = useState({});

  const getCurrences = useCallback(() => {
    setLoading( prev => ({ ...prev, loadingCurrencies : true }) );
    axios.get( process.env.REACT_APP_API_URI+"/school/fees/currencies", {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} ).then( done =>{
        setCurrencies(done.data);
      }).catch( error => {
          requestError({error});
      }).finally( () => {
          setLoading( prev => ({ ...prev, loadingCurrencies : false }) );
      })
  }, [extractTokenFromUrl]);

  useEffect( () => {
    if(show) {
      getCurrences();
      form.resetFields();
      form.resetFields();
      setItems([]);
    }
  }, [form, getCurrences, show])

  const savePayment = () => {
    setLoading( prev => ({ ...prev, savingPayment : true }) );
    const url = process.env.REACT_APP_API_URI+"/schools/subscriptions/payments";
    axios.post( url ,{ ...form.getFieldsValue(), date : moment(form.getFieldValue('date')).format('YYYY-MM-DD'), type, items, schoolId }, {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} ).then( done =>{
        message.success(done.data.res);
        getPayments();
        form.resetFields();
        setItems([]);
        setOpenModal(false);
    }).catch( error => {
        requestError({error});
    }).finally( done =>{
      setLoading( prev => ({ ...prev, savingPayment : false }) );
    })
  }


  return (
    <>
    
      <Modal 
      title={ 'Payment' }
      open={show} 
      onOk={()=>setOpenModal(false)} 
      onCancel={()=>setOpenModal(false)}
      footer={[
        <Button variant="dashed" color='blue' htmlType='submit' form='invoice-payment-form' loading={loading?.savingPayment} >
            Add Payment
        </Button>,  
        <Button key="cancel" type=""  onClick={()=>{setOpenModal(false)}} danger>
            Close
        </Button>
      ]}
      >
        <Divider style={{ marginTop:13 }}/>
        <Form
        layout="vertical"
        className="row-col"
        onFinish={ savePayment }
        id="invoice-payment-form" 
        form={form}
        >
            <Row gutter={[10,1]}>
                <Col span={24}>
                    <Form.Item
                    name="description"
                    rules={[
                        { required: true, message: "Enter Payment description!" },
                    ]}
                    >
                        <Input placeholder='Payment description'/>
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item
                    name="date"
                    
                    rules={[
                        { required: true, message: "Enter Quotation date!" },
                    ]}
                    >
                        <DatePicker format={'DD/MM/YYYY'} style={{ width: "100%" }} />
                    </Form.Item>
                </Col>
                <Col span={8}>
                <Form.Item
                name="currencyId"
                
                rules={[
                    { required: true, message: "Select Month!" },
                ]}
                >
                <Select
                    showSearch
                    placeholder="Currency"
                    optionFilterProp="children"
                    style={{ height: 29, width: "100%" }}
                >
                    {currences.map((currency) => (
                        <Option value={currency?.id} key={currency?.id}>
                            {currency?.name}
                        </Option>
                    ))}
                </Select>
                </Form.Item>
            </Col>

            <Col span={8}>
                <Form.Item
                name="amount"
                
                rules={[
                    { required: true, message: "Please input Amount!" },
                ]}
                >
                <Input type='number' step={0.01} placeholder="Amount!" />
                </Form.Item>
            </Col>

            </Row>
        </Form>

      </Modal>
    </>
  );
};

export default PaymentModal;
